import { useImmer } from "use-immer";

import { IgTextField } from "@intelligems/ig-theme";
import { ExpressionNodeQueryType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { isJavaScriptExpressionValid } from "../../utils/validators";

interface JavascriptValueProps {
  value: string;
  onChange: (
    value: any,
    changeKey: Exclude<keyof ExpressionNodeQueryType, "type">
  ) => void;
}

export const JavascriptValue = ({ value, onChange }: JavascriptValueProps) => {
  const [error, setError] = useImmer<string | null>(null);
  let errorMessage = error || "";
  if (errorMessage.includes("is not defined")) {
    errorMessage += " Hint: Access your variable through the window object";
  }

  return (
    <Grid
      item
      container
      direction={"row"}
      alignItems={"center"}
      columnSpacing={3}
    >
      <Grid item sx={{ width: "100%" }}>
        <IgTextField
          error={error !== null}
          fullWidth={true}
          label={errorMessage}
          placeholder={"ex. window.testVar == true"}
          value={value || ""}
          onChange={(e) => {
            onChange(e.target.value ?? "", "value");
            setError(isJavaScriptExpressionValid(e.target.value).errorMessage);
          }}
        />
      </Grid>
    </Grid>
  );
};
